// extracted by mini-css-extract-plugin
module.exports = {"tabbedNav":"tabChallenges_tabbedNav__1sEOz","selected":"tabChallenges_selected__2m7bW","inputs":"tabChallenges_inputs__2ChmW"};